import { useAdminApiRequest } from "./useApiRequest";

export const usePassConfigurationDisplayName = (
  businessId: string | undefined,
  passConfigurationId: string | undefined
): { displayName: string | null; refresh: () => void } => {
  const { data, refresh } = useAdminApiRequest(
    (apiClient) =>
      businessId && passConfigurationId
        ? apiClient.getPassConfiguration(businessId, passConfigurationId)
        : null,
    [businessId, passConfigurationId]
  );

  return { displayName: data?.DisplayName ?? null, refresh };
};
